import { useCallback, useEffect, useState } from "react";
import { LotteryDto, LotteryWinnersDto } from "../api/Dtos";
import { useGlobalContext } from "../Layout/GlobalState";
import { DELETE, GET, POST } from "../api/BackendApi";
import { start } from "repl";

export function useLotteriesFromBackend() {
  const globalContext = useGlobalContext();
  const [lotteries, setLotteries] = useState<Array<LotteryDto>>([]);
  const [loading, setLoading] = useState<boolean>(false);

  // Get startgroups from backend
  useEffect(() => {
    if (globalContext.competition) {
      setLoading(true);
      GET.allLotteriesInCompetition(globalContext.competition.id).then(
        (lotteries: Array<LotteryDto>) => {
          //lotteries.sort((a, b) => a.name.localeCompare(b.name));
          setLotteries(lotteries);
        }
      ).catch((error) => {
        console.error('Error fetching lotteries:', error);
      }).finally(() => {
        setLoading(false);
      });
    }
  }, [globalContext.competition]);

  return { lotteries, setLotteries, loading };
}

export function useLotteryWinnersFromBackend(lotteryId: number | null) {
  //const globalContext = useGlobalContext();
  const [lotteryWinners, setLotteryWinners] = useState<Array<LotteryWinnersDto>>([]);
  //const [loading, setLoading] = useState<boolean>(false);

  // Get startgroups from backend
  useEffect(() => {
    if (lotteryId !== null && lotteryId > 0) {
      //setLoading(true);
      GET.allLotteryWinnersInLottery(lotteryId).then(
        (winners: Array<LotteryWinnersDto>) => {
          setLotteryWinners(winners);
        }
      ).catch((error) => {
        console.error('Error fetching lottery winners:', error);
      }).finally(() => {
        //setLoading(false);
      });
    }
  }, [lotteryId]);

  return { lotteryWinners, setLotteryWinners };
}

export function lotteryService() {
  const [lotteries, setLotteries] = useState<Array<LotteryDto>>([]);
  const globalContext = useGlobalContext();

  const fetchLotteries = async (): Promise<LotteryDto[]> => {
    try {
      if (globalContext.competition) {
        const lotteries = await GET.allLotteriesInCompetition(globalContext.competition.id);
        return lotteries;
      } else {
        return lotteries;
      }
    }
    catch (error) {
      console.error('Error fetch all lotteriesByCompetitionTag: ', error);
      throw error;
    }
  };

  const GetLotteries = async () => {
    try {
      const lotteries: LotteryDto[] = await fetchLotteries();
      return lotteries;
    } catch (error) {
      console.error('Error fetch all lotteriesByCompetitionTag: ', error);
      throw error;
    }
  };

  return { lotteries: GetLotteries };
};


// export interface DisciplineStartgroupMapping {
//   id: number;
//   startgroup: Startgroup;
//   discipline: Discipline;
// }

// export function useDisciplineStartgroupMappings() {
//   const globalContext = useGlobalContext();
//   const [persistedMappings, setPersistedMappings] = useState<Array<DisciplineStartgroupMapping>>([]);

//   useEffect(() => {
//     if (globalContext.competition) {
//       GET.allDisciplineStartgroupMaps()
//       .then((response) => {
//         const startgroupIds = globalContext.competition?.startgroups.map(s => s.id);
//         const mappingsForCompetition = response.filter(m => startgroupIds?.includes(m.startgroupId));

//         return mappingsForCompetition.map(m => ({
//           id: m.id,
//           discipline: globalContext.competition?.disciplines.find((d) => d.id === m.disciplineId),
//           startgroup: globalContext.competition?.startgroups.find((s) => s.id === m.startgroupId)
//         } as DisciplineStartgroupMapping));
//       })
//       .then((parsedResponse) => {
//         setPersistedMappings(parsedResponse.sort((a,b) => a.startgroup.starttime_planned - b.startgroup.starttime_planned));
//       })
//     }
//   }, []);

//   const saveMapping = useCallback(async (startgroup: Startgroup, disciplines: Array<Discipline>) => {
//     const existingMappings = persistedMappings.filter(m => m.startgroup.id === startgroup.id);
//     const newTargetMappings = disciplines.map(d => ({id:-1, discipline: d, startgroup: startgroup} as DisciplineStartgroupMapping));

//     const mappingsToDelete = existingMappings.filter(m => !(disciplines.map(d => d.id).includes(m.discipline.id)));
//     const mappingsToCreate = newTargetMappings.filter(m => !(existingMappings.map(m => m.discipline.id).includes(m.discipline.id)));

//     const added = [] as Array<DisciplineStartgroupMapping>;
//     for (let m of mappingsToCreate) {
//       try {
//         const newMapping = await POST.disciplineStartgroupMapping(m.startgroup.id, m.discipline.id);

//         if (m.discipline.id === newMapping.disciplineId && m.startgroup.id === newMapping.startgroupId) {
//           added.push({...m, id: newMapping.id});
//         }
//       }
//       catch (e) {
//         console.error("Failed to add new DisciplineStartgroupMapping", m);
//       }
//     }

//     const deleted = [] as Array<DisciplineStartgroupMapping>;
//     for (let m of mappingsToDelete) {
//       try {
//         const removedMapping = await DELETE.disciplineStartgroupMapping(m.id);

//         if (m.discipline.id === removedMapping.disciplineId && m.startgroup.id === removedMapping.startgroupId) {
//           deleted.push({...m, id: removedMapping.id});
//         }
//       }
//       catch (e) {
//         console.error("Failed to remove DisciplineStartgroupMapping", m);
//       }
//     }

//     setPersistedMappings((old) => {
//       const updatedMappings = [...old, ...added].sort((a, b) => a.startgroup.starttime_planned - b.startgroup.starttime_planned);
//       return updatedMappings.filter(m => !deleted.map(d => d.id).includes(m.id));
//     })
//   }, [persistedMappings, setPersistedMappings]);

//   return {persistedMappings, saveMapping};
// }